export type LiconicInstrumentTypes = 'liconic_stx' | 'liconic_str' | 'liconic_lpx'
export type SingleTransferStationInstrumentTypes = 'cytation' | 'yokogawa_cq1'

export function isLiconicInstrument(
  instrumentType: string,
): instrumentType is LiconicInstrumentTypes {
  return ['liconic_stx', 'liconic_str', 'liconic_lpx'].includes(instrumentType)
}

export function isSingleTransferStationInstrument(
  instrumentType: string,
): instrumentType is SingleTransferStationInstrumentTypes {
  return [
    'cytation',
    'yokogawa_cq1',
    'opentrons_temperature_module',
    'opentrons_heater_shaker',
    'coldplate',
    'bioshake_q1',
    'bb_shaker',
    'attune_nxt',
  ].includes(instrumentType)
}
